// ... existing code ...
const footerLinks = {
  "Services": ["Heating Repair", "Furnace Replacement", "AC Repair & Install", "Heat Pump Systems", "Indoor Air Quality", "Annual Tune-Up Plans"],
  "Company": ["About Ultimate", "Service Areas", "Careers", "Contact Us"],
  "Resources": ["Service Area Map", "Privacy Policy"],
};

const certifications = [
  "CT License: HTG.0412509-S2",
  "NOCTI-Certified",
  "EPA Section 608",
];

export default function Footer() {
  return (
    <footer className="bg-[#091535] text-gray-300">
      {/* Main footer */}
      <div className="max-w-7xl mx-auto px-5 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-5 gap-8 md:gap-10">
          {/* Brand */}
          <div className="md:col-span-2">
            <div className="flex items-center gap-3 mb-5">
              <div className="w-10 h-10 flex items-center justify-center bg-[#C8102E] rounded-full">
                <i className="ri-temp-hot-line text-white text-lg"></i>
              </div>
              <div>
                <div className="text-white font-extrabold text-base leading-tight" style={{ fontFamily: "'Montserrat', sans-serif" }}>Ultimate</div>
                <div className="text-[#C8102E] text-[9px] font-bold tracking-[0.2em] uppercase">Heating &amp; Cooling</div>
              </div>
            </div>
            <p className="text-gray-500 text-xs leading-relaxed mb-5 max-w-xs">
              Connecticut&apos;s trusted HVAC specialists. Licensed, and committed to total home comfort
            </p>
            <div className="space-y-3 text-sm">
              <div className="flex items-start gap-3">
                <span className="w-4 h-4 flex items-center justify-center flex-shrink-0 mt-0.5">
                  <i className="ri-phone-fill text-[#C8102E] text-xs"></i>
                </span>
                <a href="tel:9592418524" className="text-gray-300 hover:text-white transition-colors cursor-pointer text-sm">(959) 241-8524</a>
              </div>
              <div className="flex items-start gap-3">
                <span className="w-4 h-4 flex items-center justify-center flex-shrink-0 mt-0.5">
                  <i className="ri-map-pin-line text-[#C8102E] text-xs"></i>
                </span>
                <address className="not-italic text-gray-500 text-xs leading-relaxed">
                  Somers, CT 06071
                </address>
              </div>
              <div className="flex items-start gap-3">
                <span className="w-4 h-4 flex items-center justify-center flex-shrink-0 mt-0.5">
                  <i className="ri-mail-line text-[#C8102E] text-xs"></i>
                </span>
                <a href="mailto:service@ultimatehvac.com" className="text-gray-500 text-xs hover:text-white transition-colors cursor-pointer">
                  service@ultimatehvac.com
                </a>
              </div>
            </div>

            {/* Social icons */}
            <div className="flex gap-2 mt-6">
              {[
                { icon: "ri-facebook-fill", href: "https://www.facebook.com/ultimate.heating.and.cooling.mechanical.llc" },
              ].map((s) => (
                <a
                  key={s.icon}
                  href={s.href}
                  className="w-8 h-8 flex items-center justify-center bg-white/5 hover:bg-[#C8102E] rounded-full transition-colors cursor-pointer"
                >
                  <i className={`${s.icon} text-xs text-white`}></i>
                </a>
              ))}
            </div>
          </div>

          {/* Link columns - on mobile display as 2-column grid */}
          <div className="md:contents grid grid-cols-2 gap-8 md:gap-0">
            {Object.entries(footerLinks).map(([heading, links]) => (
              <div key={heading}>
                <h4 className="text-white text-[10px] font-bold tracking-[0.15em] uppercase mb-4 pb-2.5 border-b border-white/10">
                  {heading}
                </h4>
                <ul className="space-y-2.5">
                  {links.map((link) => (
                    <li key={link}>
                      <a href="#" className="text-gray-500 text-xs hover:text-[#C8102E] transition-colors cursor-pointer">
                        {link}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Divider */}
      <div className="border-t border-white/5"></div>

      {/* Bottom bar */}
      <div className="max-w-7xl mx-auto px-5 md:px-6 py-5">
        <div className="flex flex-col md:flex-row items-center justify-between gap-3">
          <div className="text-[11px] text-gray-600 text-center md:text-left">
            <p>
              <strong className="text-gray-500">Licenses &amp; Certifications: </strong>
              <span className="hidden sm:inline">{certifications.join(" • ")}</span>
              <span className="sm:hidden">{certifications.slice(0, 2).join(" • ")}</span>
            </p>
          </div>
          <div className="text-[11px] text-gray-600 text-center">
            <p>&copy; 2026 Ultimate Heating &amp; Cooling, LLC. All rights reserved.</p>
            <p className="mt-1">
              <a href="#" className="hover:text-gray-400 cursor-pointer">Privacy Policy</a>
              <span className="mx-2">•</span>
              <a href="#" className="hover:text-gray-400 cursor-pointer">Service Areas</a>
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}
